function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* global auth */
import React, { useCallback, useEffect, useState } from "react";
import { MenuBar as MenuBarPresentation, MenuBarSpacer } from "@muchbetteradventures/styleguide";
import { withAuth } from "@muchbetteradventures/signup-form-lib";
import ErrorBoundary from "./ErrorBoundary";
import NavDrawer from "./NavDrawer";
import UserMenu from "./UserMenu";
import { AlgoliaConfigMemo } from "./search/AlogliaConfig";
import { SearchDrawerAuthedMemo } from "./search/Drawer";

var MenuBar = function MenuBar(_ref) {
  var algoliaAppId = _ref.algoliaAppId,
      algoliaProductIndex = _ref.algoliaProductIndex,
      algoliaPublicApiKey = _ref.algoliaPublicApiKey,
      currentUser = _ref.currentUser,
      menu = _ref.menu,
      trackEvent = _ref.trackEvent,
      onClickRegionSelector = _ref.onClickRegionSelector,
      _ref$showRegionSelect = _ref.showRegionSelector,
      showRegionSelector = _ref$showRegionSelect === void 0 ? false : _ref$showRegionSelect;

  // Drawer States
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      megaMenuOpen = _useState2[0],
      setMegaMenuOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      searchDrawerOpen = _useState4[0],
      setSearchDrawerOpen = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      menuAnchorEl = _useState6[0],
      setMenuAnchorEl = _useState6[1]; // Mega Menu


  var openMegaMenu = useCallback(function () {
    setMegaMenuOpen(true);
    setSearchDrawerOpen(false);
    setMenuAnchorEl(null);
    trackEvent("Open Hamburger Menu");
  }, [trackEvent]);
  var closeMegaMenu = useCallback(function () {
    setMegaMenuOpen(false);
    trackEvent("Close Hamburger Menu");
  }, [trackEvent]);
  var toggleMegaMenu = useCallback(function () {
    if (megaMenuOpen) closeMegaMenu();else openMegaMenu();
  }, [megaMenuOpen]); // Search Drawer

  var openSearchDrawer = useCallback(function () {
    setSearchDrawerOpen(true);
    setMegaMenuOpen(false);
    setMenuAnchorEl(null);
    trackEvent("Open Search Drawer");
  }, [trackEvent]);
  var closeSearchDrawer = useCallback(function () {
    setSearchDrawerOpen(false);
    trackEvent("Close Search Drawer");
  }, [trackEvent]);
  var toggleSearchDrawer = useCallback(function () {
    if (searchDrawerOpen) closeSearchDrawer();else openSearchDrawer();
  }, [searchDrawerOpen]); // User Menu

  var openUserMenu = useCallback(function (event) {
    setMenuAnchorEl(event.currentTarget);
    setMegaMenuOpen(false);
    setSearchDrawerOpen(false);
    trackEvent("Open User Menu");
  }, [trackEvent]);
  var closeUserMenu = useCallback(function () {
    setMenuAnchorEl(null);
    trackEvent("Close User Menu");
  }, [trackEvent]); // Client/Server State

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isClient = _useState8[0],
      setIsClient = _useState8[1];

  useEffect(function () {
    setIsClient(true);
  }, []); // Authentication

  var loggedIn = Boolean(currentUser);
  var isHost = Boolean(currentUser && currentUser.is_host);
  var isStaff = Boolean(currentUser && currentUser.is_staff);
  var signIn = useCallback(function () {
    return auth && auth.signIn({
      preventSwitchFromSigninForm: true
    });
  }, []);
  var signUp = useCallback(function () {
    return auth && auth.signUp({
      preventSwitchFromSignupForm: true
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuBarSpacer, null), /*#__PURE__*/React.createElement(MenuBarPresentation, {
    disabledChat: !isClient,
    disabledHamburger: !isClient,
    hrefSearch: !isClient ? "/explore/" : undefined,
    hrefUser: !isClient ? "/accounts/login/" : undefined,
    isFixedPosition: true,
    isHamburgerOpen: megaMenuOpen,
    logoHref: "/",
    onClickHamburgerMenu: toggleMegaMenu,
    onClickSearch: isClient ? toggleSearchDrawer : undefined,
    onClickUser: isClient ? openUserMenu : undefined,
    onClickRegionSelector: isClient ? onClickRegionSelector : undefined,
    regionSelectorDisabeled: !isClient,
    showRegionSelector: showRegionSelector
  }), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(NavDrawer, {
    open: megaMenuOpen,
    onClose: closeMegaMenu,
    menu: menu
  })), isClient && /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(AlgoliaConfigMemo, {
    algoliaAppId: algoliaAppId,
    algoliaPublicApiKey: algoliaPublicApiKey,
    algoliaProductIndex: algoliaProductIndex,
    disableAnalytics: isStaff
  }, /*#__PURE__*/React.createElement(SearchDrawerAuthedMemo, {
    open: searchDrawerOpen,
    onClose: closeSearchDrawer,
    trackEvent: trackEvent
  }))), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(UserMenu, {
    anchorEl: menuAnchorEl,
    isHost: isHost,
    isStaff: isStaff,
    loggedIn: loggedIn,
    onClose: closeUserMenu,
    onSignIn: signIn,
    onSignUp: signUp
  })));
};

var AuthedMenuBar = withAuth(MenuBar);
export default AuthedMenuBar;